import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Menubar = ({ isOpen, onClose }) => {
  const location = useLocation();
  return (
    <div
      className="menubar"
      style={{
        width: isOpen ? "228.06px" : "70px",
        transition: "width 0.3s ease-in-out",
        overflow: "hidden",
      }}
    >
      <Link
        to="/"
        className={
          location.pathname === "/" ? "sidebarlink active" : "sidebarlink"
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M12.5 17.5V10.8333C12.5 10.6123 12.4122 10.4004 12.2559 10.2441C12.0996 10.0878 11.8877 10 11.6667 10H8.33333C8.11232 10 7.90036 10.0878 7.74408 10.2441C7.5878 10.4004 7.5 10.6123 7.5 10.8333V17.5"
            stroke="#606367"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.5 8.33333C2.49994 8.09088 2.55278 7.85134 2.65482 7.63142C2.75687 7.4115 2.90566 7.21649 3.09083 7.05999L8.92417 2.05999C9.22499 1.80575 9.60613 1.66626 10 1.66626C10.3939 1.66626 10.775 1.80575 11.0758 2.05999L16.9092 7.05999C17.0943 7.21649 17.2431 7.4115 17.3452 7.63142C17.4472 7.85134 17.5001 8.09088 17.5 8.33333V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V8.33333Z"
            stroke="#606367"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {isOpen && "Home"}
      </Link>
      <Link
        to="/tothemoon"
        className={
          location.pathname === "/tothemoon"
            ? "sidebarlink active"
            : "sidebarlink"
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 2.5C9.00544 3.49456 8.4467 4.84348 8.4467 6.25C8.4467 7.65652 9.00544 9.00544 10 10C10.9946 10.9946 12.3435 11.5533 13.75 11.5533C15.1565 11.5533 16.5054 10.9946 17.5 10C17.5 11.4834 17.0601 12.9334 16.236 14.1668C15.4119 15.4001 14.2406 16.3614 12.8701 16.9291C11.4997 17.4968 9.99168 17.6453 8.53682 17.3559C7.08196 17.0665 5.74559 16.3522 4.6967 15.3033C3.6478 14.2544 2.9335 12.918 2.64411 11.4632C2.35472 10.0083 2.50325 8.50032 3.0709 7.12987C3.63856 5.75943 4.59985 4.58809 5.83322 3.76398C7.06659 2.93987 8.51664 2.5 10 2.5Z"
            stroke="#606367"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {isOpen && "Crash"}
      </Link>
      <Link
        to="/play"
        className={
          location.pathname === "/play" 
            ? "sidebarlink active"
            : "sidebarlink"
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6.66667 11.6667C9.42809 11.6667 11.6667 9.42808 11.6667 6.66666C11.6667 3.90523 9.42809 1.66666 6.66667 1.66666C3.90524 1.66666 1.66667 3.90523 1.66667 6.66666C1.66667 9.42808 3.90524 11.6667 6.66667 11.6667Z"
            stroke="#606367"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.075 8.64166C15.8628 8.93535 16.5637 9.42294 17.1131 10.0593C17.6625 10.6957 18.0426 11.4604 18.2181 12.2826C18.3937 13.1047 18.3591 13.9579 18.1175 14.7632C17.876 15.5685 17.4353 16.2998 16.8362 16.8897C16.2371 17.4795 15.4989 17.9087 14.69 18.1377C13.881 18.3666 13.0274 18.3879 12.2081 18.1995C11.3887 18.0112 10.6301 17.6192 10.0024 17.06C9.37462 16.5007 8.89803 15.7922 8.61667 15"
            stroke="#606367"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.83333 5H6.66667V8.33333"
            stroke="#606367"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.925 11.5667L14.5083 12.1583L12.1583 14.5083"
            stroke="#606367"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {isOpen && "Dice"}
      </Link>
            <Link
        to="/liquidity"
        className={
         location.pathname === "/liquidity"
            ? "sidebarlink active"
            : "sidebarlink"
        }
      >
   <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#606367"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 2C12 2 6 9 6 14a6 6 0 0012 0c0-5-6-12-6-12z" />
  <path d="M12 10v4" />
  <path d="M10 12h4" />
</svg>

        {isOpen && "liquidity"}
      </Link>
    </div>
  );
};

export default Menubar;
